import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { SITE_URL } from '../config/site';
import './PageStyles.css';

const NotFoundPage = () => (
  <div className="page-container">
    <SEO
      title="Page Not Found | Dr. Muyabins Dental Care"
      description="The page you are looking for could not be found."
      url={`${SITE_URL}/404`}
      noindex
    />
    <div className="page-header" style={{ textAlign: 'center', padding: '60px 20px' }}>
      <h1>404 — Page Not Found</h1>
      <p style={{ marginBottom: '32px' }}>
        Sorry, we could not find that page. Try one of these instead:
      </p>
      <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link to="/" className="btn-primary">Home</Link>
        <Link to="/services" className="btn-secondary">Services</Link>
        <Link to="/appointment" className="btn-secondary">Book Appointment</Link>
        <Link to="/contact" className="btn-secondary">Contact</Link>
      </div>
    </div>
  </div>
);

export default NotFoundPage;
